import React from 'react';
import { HeaderText, Description, CategoryDescriptionContainer, Header, HeaderCode, } from '@@Pages/CategoryPage/CategoryDescription/styled';
export const CategoryDescription = ({ category }) => {
    return (React.createElement(React.Fragment, null, category && (React.createElement(CategoryDescriptionContainer, null,
        React.createElement(Header, null,
            React.createElement(HeaderText, null, category.name),
            React.createElement(HeaderCode, null, category.product_count > 0 && `(${category.product_count})`)),
        category.description && (React.createElement(Description, null, category.description))))));
};
